import styled, { css } from 'styled-components';

import { mediaMaxQuery, mediaQuery } from '../../../styles/mixin';

export const Container = styled.div`
    padding: 1.5rem;
    ${mediaQuery(
        2,
        css`
            padding: 2rem;
        `
    )}
`;

export const LogoContainer = styled.div`
    width: 13.2rem;
    height: auto;
`;

export const Header = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const NavContainer = styled.nav`
    ${mediaMaxQuery(
        2,
        css`
            .showMobile {
                text-align: center;
                padding: 0;
                font-size: 0.9em;
                border: none;
            }
        `
    )}

    ${mediaQuery(
        2,
        css`
            display: flex;
            align-items: center;
        `
    )}
`;

export const Content = styled.main`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    margin-top: 3rem;
    ${mediaQuery(
        2,
        css`
            margin-top: 0rem;
        `
    )}
`;
